// extracted by mini-css-extract-plugin
export default {"meals":"AvailableMeals_meals__bJQ+2","meals-appear":"AvailableMeals_meals-appear__l2cHo"};